<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-16">
        <h4 class="mt-3 mb-4">Click-Through-Rate (CTR / Klickrate) berechnen</h4>

      </div>
    </div>
    <div class="row">
      <div :class="calcValues.ctr.isResult ? 'col-lg-7' : 'col-16'">
        
        <div class="row mt-3">
          <div class="col-16">
            
            <label class="form-label">Anzahl Klicks</label>


            <div class="input-group mb-3">
              <input type="text" class="form-control" v-model="formatClicks" @focus="$event.target.select()">
              <span v-if="calcValues.clicks.suffix !== ''" class="input-group-text" v-html="calcValues.clicks.suffix"></span>
            </div>
            

            <label class="form-label">Anzahl Einblendungen / Impressionen</label>
            <div class="input-group mb-3">
              <input type="text" class="form-control" v-model="formatImpressions" @focus="$event.target.select()">
              <span v-if="calcValues.impressions.suffix !== ''" class="input-group-text" v-html="calcValues.impressions.suffix"></span>
            </div>
          
            
          </div>

        </div>
      </div>
      <div class="col-lg-9" v-if="calcValues.ctr.isResult">
        <h5>Ergebnis</h5>

        <p>Deine Click-Through-Rate <span v-if="calcValues.ctrAvg.text != ''">ist <span class="sb-bold">{{ calcValues.ctrAvg.text }}</span> und </span>beträgt: <span class="sb-bold">{{ calcValues.ctr.formatted }} <span v-html="calcValues.ctr.suffix"></span></span>.</p>

      </div>
    </div>
  


 </div>
</template>

<script>
export default {
  name: "clickThroughRate",
  data() {
    return {
      calcValues: {
        impressions: {
          number: 0,
          formatted: '',
          suffix: '',
          isResult: false,
        },
        clicks: {
          number: 0,
          formatted: '',
          suffix: '',
          isResult: false,
        },
        ctr: {
          number: 0,
          formatted: '',
          suffix: '%',
          isResult: false,
        },
        ctrAvg: {
          number: 0,
          formatted: '',
          suffix: '%',
          isResult: false,
          text: '',
        },
      }

    }
  },
  computed: {
    formatClicks: {
      get () {
        return this.getObj('clicks').number;
      },
      set (value) {
        return this.setObj('clicks', value, 1);
      }
    },
    formatImpressions: {
      get () {
        return this.getObj('impressions').number;
      },
      set (value) {
        return this.setObj('impressions', value, 1);
      }
    },
  },
  methods: {
    formatStr2Number(str) {
      var number = Number(str.toString().replace(',','.'));
      //console.log(number, typeof number);
      if (isNaN(number)) number = 0;
      return number;
    },
    setResult(name, result) {
      let obj = this.getObj(name);
      obj.isResult = result;
      this.calcValues[name] = obj;
    },
    setObj(name, value, calcResult) {
      let obj = this.getObj(name);
      obj.number = this.formatStr2Number(value);
      obj.formatted = this.beautifier(obj.number);
      //console.log(obj.number, obj.formatted);
      this.calcValues[name] = obj;

      if (calcResult) this.calcResult();

      return obj.number;
    },
    setObjContent(name, obj, calcResult) {
      this.calcValues[name] = obj;
      this.setObj(name, obj.number, calcResult);
    },
    getObj(name) {
      return this.calcValues[name];
    },
    beautifier(value) {
      return Number(value).toLocaleString("de-DE", {minimumFractionDigits: 2, maximumFractionDigits: 2});
    },
    calcResult() {

      let clicks = this.calcValues.clicks;
      let impressions = this.calcValues.impressions;
      let ctr = this.calcValues.ctr;
      let ctrAvg = this.calcValues.ctrAvg;

      //Formel: clicks / impressions * 100

      if (impressions.number == 0) {

        ctr.number = 0;
        ctr.isResult = false;
        this.setObjContent('ctr',  ctr, 0);

        ctrAvg.text = '';
        ctrAvg.isResult = false;
        this.setObjContent('ctrAvg',  ctrAvg, 0);

      } else {

        ctr.number = clicks.number / impressions.number * 100;
        ctr.isResult = true;
        this.setObjContent('ctr',  ctr, 0);

        if (ctr.number > 0
          && ctr.number < 4
        ) {

          ctrAvg.text = 'schlecht';
          ctrAvg.isResult = true;
          this.setObjContent('ctrAvg',  ctrAvg, 0);

        } else if (ctr.number >= 4
            && ctr.number <= 6
        ) {

          ctrAvg.text = 'durchschnittlich';
          ctrAvg.isResult = true;
          this.setObjContent('ctrAvg',  ctrAvg, 0);

        } else  if (ctr.number > 6
        ) {

          ctrAvg.text = 'sehr gut';
          ctrAvg.isResult = true;
          this.setObjContent('ctrAvg',  ctrAvg, 0);

        }



      }

    }
  }
}
</script>

<style scoped>

</style>